import type { EvidenceSection } from 'api/brokerCases/types';
import { MOCK_BORROWER } from './mockBorrower';
import { useBorrower } from 'queries';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getProgressFromSections, mapBorrowerToApplicantOptions } from './helpers';
import { EvidenceList, EvidenceProgressCard } from './components';
import { Typography } from 'antd';
import { TypedFormatMessageFn } from 'types/intl';

export interface EvidencePageProps {
  caseId: string;
  sections: EvidenceSection[];
  isCaseTasksLoading: boolean;
}

export const EvidencePage = ({ caseId, sections, isCaseTasksLoading }: EvidencePageProps) => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const { data: borrower, isLoading } = useBorrower(caseId);

  const individuals = useMemo(() => mapBorrowerToApplicantOptions(borrower ?? MOCK_BORROWER), [borrower]);

  const progress = getProgressFromSections(sections);

  if (isLoading) {
    return <Typography.Text>{formatMessage({ id: 'evidence.page.loading' })}</Typography.Text>;
  }

  return (
    <div className='w-full min-h-screen flex gap-6 flex-col pb-10'>
      <EvidenceProgressCard progress={progress} />
      <EvidenceList sections={sections} individuals={individuals} isCaseTasksLoading={isCaseTasksLoading} />
    </div>
  );
};
